module.exports = __webpack_public_path__ + "img/ipgone_page4.69ba1cf5.png";